import type { PlayerEventMap } from '@vimeo/player-types';

export const propsToEvent: Record<string, keyof PlayerEventMap> = {
  onPlay: 'play',
  onPlaying: 'playing',
  onPause: 'pause',
  onEnded: 'ended',
  onTimeupdate: 'timeupdate',
  onProgress: 'progress',
  onSeeking: 'seeking',
  onSeeked: 'seeked',
  onLoadedMetadata: 'loadedmetadata',
  onTexttrackchange: 'texttrackchange',
  onChapterchange: 'chapterchange',
  onCuechange: 'cuechange',
  onCuepoint: 'cuepoint',
  onVolumechange: 'volumechange',
  onPlaybackratechange: 'playbackratechange',
  onBufferstart: 'bufferstart',
  onBufferend: 'bufferend',
  onError: 'error',
  onLoaded: 'loaded',
  onDurationchange: 'durationchange',
  onFullscreenchange: 'fullscreenchange',
  onQualitychange: 'qualitychange',
  onCamerachange: 'camerachange',
  onResize: 'resize',
  onEnterpictureinpicture: 'enterpictureinpicture',
  onLeavepictureinpicture: 'leavepictureinpicture',
  onRemoteplaybackavailabilitychange: 'remoteplaybackavailabilitychange',
  onRemoteplaybackconnecting: 'remoteplaybackconnecting',
  onRemoteplaybackconnect: 'remoteplaybackconnect',
  onRemoteplaybackdisconnect: 'remoteplaybackdisconnect',
  onInteractivehotspotclicked: 'interactivehotspotclicked',
  onInteractiveoverlaypanelclicked: 'interactiveoverlaypanelclicked',
};
